import { MenuItems } from '@menu-lib/components/AppLayout/MainMenu/menuItems';
import { MenuItemRegistry } from '@menu-lib/components/AppLayout/MainMenu/menuRegistry';
import { type EnvironmentSettings, type HeaderItem } from '@menu-lib/components/AppLayout/types';

MenuItemRegistry.register(MenuItems.OverzichtenHeader, {
  isVisible: (settings: EnvironmentSettings) =>
    settings.isActiveAdviseur || settings.isMaatschappij || settings.isInterneGebruiker,
  create: (): HeaderItem => ({
    itemtype: 'header',
    menuItem: MenuItems.OverzichtenHeader,
    title: 'Overzichten',
  }),
});
